import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {PencilSquareIcon} from "@heroicons/react/24/outline";
import {SurveyOldVersionWarning} from "@components/SurveyOldVersionWarning";

const ConfiguratorSurveyGetTitle = ({
  service,
  survey,
  creators,
  setEditedSurveyData=undefined,
  freezed=false,
}) => {

  const intl = useIntl();

  const isoStr1 = survey['created_at'];
  const date = new Date(isoStr1);
  const timestampWithOffset = date.getTime();
  const offset = date.getTimezoneOffset() * 60 * 1000;
  const timestampWithoutOffset = timestampWithOffset - offset;
  const dateWithoutOffset = new Date(timestampWithoutOffset);

  let dateWithoutOffsetM
  if (survey['modified_at']) {
    const isoStrM = survey['modified_at'];
    const dateM = new Date(isoStrM);
    const timestampWithOffsetM = dateM.getTime();
    const timestampWithoutOffsetM = timestampWithOffsetM - offset;
    dateWithoutOffsetM = new Date(timestampWithoutOffsetM);
  }

  const creator = survey.id_creator && creators[survey.id_creator]
  const modifier = survey.id_modifier && creators[survey.id_modifier]

  return <div className="flex flex-col gap-0.5">
    <div className="flex items-center justify-start gap-1.5">
      {!!setEditedSurveyData && (
        <PencilSquareIcon
          className={`h-4 w-4 text-gray-400 ${freezed ? "cursor-not-allowed" : "hover:text-am-500 curosr-pointer"}`}
          onClick={() => {
            if (freezed) return;
            setEditedSurveyData({service, survey, designSurveys: []});
          }}
        />
      )}
      <span className="font-semibold">
        {survey?.name || <FormattedMessage id="unnamed_configuration" />}
      </span>
      {!!service && (
        <SurveyOldVersionWarning
          type="badge"
          name={service.name}
          version={survey.service_version}
          latest={service.active_version}
        />
      )}
    </div>
    <div>
      {survey.complete
        ? <p className="text-xs">
          {`${intl.formatMessage({id: "created_on"})} `}
          <span className="capitalize">
            {`${intl.formatDate(new Date(dateWithoutOffset), {day: "numeric", month: "long", year: "numeric"})}`}
          </span>
          <span>
            {` ${intl.formatMessage({id: "at"})} ${intl.formatTime(new Date(dateWithoutOffset))}`}
          </span>
          {creator &&
            <span>
              {` ${intl.formatMessage({id: "by"})} ${creator['firstname']} ${creator['lastname']}`}
            </span>
          }
        </p>
        : <p className="text-xs text-gray-400">{intl.formatMessage({id: "configuration_not_completed"})}</p>
      }
      {modifier && creator && (survey.first_render === false || survey.id_creator !== survey.id_modifier) &&
        <p className="text-xs text-gray-400">
          {`${intl.formatMessage({id: "modified_on"})} `}
          <span className="capitalize">
            {`${intl.formatDate(new Date(dateWithoutOffsetM), {day: "numeric", month: "long", year: "numeric"})}`}
          </span>
          <span>
            {` ${intl.formatMessage({id: "at"})} ${intl.formatTime(new Date(dateWithoutOffsetM))}`}
          </span>
          <span>
            {` ${intl.formatMessage({id: "by"})} ${modifier['firstname']} ${modifier['lastname']}`}
          </span>
        </p>
      }
    </div>
  </div>
};

export default ConfiguratorSurveyGetTitle;
